import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as PhoneFormat from "phoneformat.js";
import * as _ from "lodash";

@Pipe({
  standalone: false,
  name: 'bringozPhone'
})

export class BringozPhonePipe implements PipeTransform {

  constructor(@Inject('splitService') private splitService) {
  }
  transform(phoneNumber: string, ...args: unknown[]): unknown {

    if (_.isUndefined(phoneNumber) || !phoneNumber) {
      return args[0];
    }

    const siteCountry = this.splitService.getCountryCode();
    const phoneCountry = PhoneFormat.countryForE164Number(phoneNumber)
    return _.isEqual(siteCountry, phoneCountry) ? PhoneFormat.formatLocal(phoneCountry, phoneNumber) : phoneNumber;

  }

}
